import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import makeResponsiveBem from "Utils/makeResponsiveBem";
import SIReactOnRails from "Utils/ReactOnRails";

import BodyText from "Common/BodyText";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("InfoBox");
const responsiveBem = makeResponsiveBem("InfoBox");
export default class InfoBox extends React.Component {
  render() {
    const { infoText } = this.props;
    return (
      <div className={classnames(isIntuit() ? bem(null, "intuit") : bem(), responsiveBem())}>
        <div className={responsiveBem("ImageContainer")}>
          <Icon icon="info-circle" size="2x" flavor="solid" />
        </div>
        <BodyText className={responsiveBem("text")} blue={!isIntuit()} weight={!isIntuit() ? "bold" : null}>
          {infoText}
        </BodyText>
      </div>
    );
  }
}
SIReactOnRails.register(
  {
    InfoBox,
  },
  module,
);
